import React, { useState } from 'react';
import { GET_FIRST_LETTER } from '../../../utils';
const Author = ({ imageSize, symbolClass, className, name, profileUrl, networkId, errorPic }) => {
    const [profileError, setProfileError] = useState(false);

    return (
        <div className={className}>
            { profileError || profileUrl === "" ? <span className={`${symbolClass} rounded-circle text-white`} style={{ backgroundColor: '#000' }}> {GET_FIRST_LETTER(name)} </span> : <img src={profileUrl} height={imageSize} width={imageSize} alt={name} onError={(e) => { errorPic ? e.target.src = errorPic : setProfileError(true) }} />}
        </div>
    );
};
export default Author;